<template>
  <div>
    <h1 class="mb-32">Общая информация</h1>
    <div class="stack-md">
      <w-info />
      <w-access />
      <w-start />
    </div>
  </div>
</template>

<script>
  import wInfo from './Info.vue'
  import wAccess from '@/components/Access.vue'
  import wStart from './Start.vue'

  export default {
    components: {
      wInfo,
      wAccess,
      wStart
    }
  }
</script>
